import React, { useEffect, useState } from "react";
import { FaAngleDown, FaChevronRight, FaCircleArrowUp } from "react-icons/fa6";
import { HiMiniBars3, HiOutlineHome } from "react-icons/hi2";
import { MdShoppingCart, MdLogout, MdCheckCircle } from "react-icons/md";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { CiViewList } from "react-icons/ci";
import { BsBoxSeam } from "react-icons/bs";
import { RiShapesFill, RiRobot2Line } from "react-icons/ri";
import { IoLocation, IoPeople } from "react-icons/io5";
import { SlGraph } from "react-icons/sl";
import { GoOrganization } from "react-icons/go";
import { IoMdSettings } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import { BsQuestionCircleFill } from "react-icons/bs";

import "./Navbar.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  clearBranches,
  updateActiveBranch,
} from "../../redux/features/branch-slice";

import { RoutesArray } from "../../constants/routes";
import ROUTES from "../../constants/routes";
import { clearUser } from "../../redux/features/user-slice";
import { clearOrganization } from "../../redux/features/organization-slice";
import { clearCart } from "../../redux/features/cart-slice";
import useOrganizationIsAllowed from "../../helpers/organizationPrevillages";
import {
  clearSubscriptionPlans,
  updateOpenSubscriptionAd,
} from "../../redux/features/subscription-slice";
import { logoutUser } from "../../api/auth";
import useUserIsAllowed from "../../helpers/userAuthorized";
import { clearHomeData } from "../../redux/features/home-slice";
import { clearAnalytics } from "../../redux/features/analytics-slice";
import { clearProducts } from "../../redux/features/products-slice";
import { storage } from "../../helpers/storage";
import { clearCustomers } from "../../redux/features/customers-slice";
import { clearOrders } from "../../redux/features/orders-slice";
import { clearSales } from "../../redux/features/sales-slice";
import CustomButton from "../CustomButton/CustomButton";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const Navbar = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.userReducer.value);

  const { steps, activeIndex } = useSelector(
    (state) => state.tourReducer.value
  );

  const {
    branches,
    name,
    id: branch_id,
  } = useSelector((state) => state.branchReducer.value);

  const organization = useSelector((state) => state.organizationReducer.value);

  const location = useLocation();
  const navigate = useNavigate();

  const [touchStart, setTouchStart] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarPosition, setSidebarPosition] = useState(-1000); // Start off-screen
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branchDropDown, setBranchDropDown] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState({ title: "DAIKO" });

  useEffect(() => {
    setSelectedBranch(name);
  }, [name]);

  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    // Only handle touches that start within the first 20px of the screen
    if (touch.clientX <= 20) {
      // e.preventDefault();
      setTouchStart({
        x: touch.clientX,
        y: touch.clientY,
      });
    }
  };

  const handleTouchMove = (e) => {
    if (!touchStart) return;

    const touch = e.touches[0];
    const currentX = touch.clientX;
    const deltaX = currentX - touchStart.x;

    // Only handle right swipes (positive deltaX)
    if (deltaX > 0) {
      // e.preventDefault();
      // Convert deltaX to a percentage of screen width
      const screenWidth = window.innerWidth;
      const maxWidth = 310; // Max width of sidebar
      const percentage = Math.min((deltaX / screenWidth) * 100, 100);
      const newPosition = Math.min(percentage * (maxWidth / 100), maxWidth);

      setSidebarPosition(newPosition - maxWidth);
    }
  };

  const handleTouchEnd = (e) => {
    if (!touchStart) return;

    // e.preventDefault();
    const screenWidth = window.innerWidth;
    const maxWidth = 310;
    const threshold = screenWidth * 0.3; // 30% of screen width

    if (sidebarPosition > -maxWidth + threshold) {
      // If dragged more than threshold, open fully
      setSidebarPosition(0);
      setSidebarOpen(true);
    } else {
      // Otherwise, close
      setSidebarPosition(-maxWidth);
      setSidebarOpen(false);
    }

    setTouchStart(null);
  };

  const closeSidebar = () => {
    setSidebarPosition(-1000);
    setSidebarOpen(false);
  };

  const openSidebar = () => {
    setSidebarPosition(0);
    setSidebarOpen(true);
  };

  useEffect(() => {
    if (steps[activeIndex]) {
      if (steps[activeIndex]?.navbar) {
        openSidebar();
      } else {
        closeSidebar();
      }
    } else {
      closeSidebar();
    }
  }, [steps, activeIndex]);

  const handleBranchChange = (branch_id) => {
    const activeBranch = branches.find((el) => el.id === branch_id);

    if (activeBranch) {
      storage.remove("sales");
      storage.remove("orders");
      storage.remove("cart");
      storage.remove("salesSummary");
      storage.remove("ordersSummary");
      dispatch(updateActiveBranch(activeBranch));
      storage.set("activeBranch", JSON.stringify(activeBranch));

      dispatch(clearSales());
      dispatch(clearOrders());
      dispatch(clearCart());
    }
  };

  useEffect(() => {
    setSidebarOpen(false);
    setSidebarPosition(-1000);
  }, [branch_id]);

  const handleLogOut = () => {
    logoutUser(user.token)
      .then((res) => {})
      .catch((err) => {});
    dispatch(clearUser());
    dispatch(clearProducts());
    dispatch(clearAnalytics());
    dispatch(clearBranches());
    dispatch(clearCart());
    dispatch(clearHomeData());
    dispatch(clearOrganization());
    dispatch(clearSubscriptionPlans());
    dispatch(clearSales());
    dispatch(clearOrders());
    dispatch(clearCustomers());
    storage.removeAll();
  };

  useEffect(() => {
    if (!sidebarOpen) {
      setBranchDropDown(false);
    }
  }, [sidebarOpen]);

  useEffect(() => {
    const tempRoute = RoutesArray.find((el) => el.path === location.pathname);

    if (tempRoute) {
      setSelectedRoute(tempRoute);
    } else {
      setSelectedRoute({ title: "DAIKO" });
    }
  }, [location]);

  const handleGoBack = () => {
    if (selectedRoute?.backPath) {
      navigate(selectedRoute.backPath);
    }
    // navigate(-1);
  };

  const orgIsAllowedToTakeOrders = useOrganizationIsAllowed("order");
  const userIsAllowedToViewAnalytics = useUserIsAllowed("view_analytics");
  const userIsAllowedToViewOrganization = useUserIsAllowed("administrator");

  return (
    <div
      className={`navbar ${selectedRoute?.hideNav ? "not-active" : ""} ${
        selectedRoute?.hideShadow ? "" : "box-shadow"
      } ${location.pathname === ROUTES.home.path ? "home-back-ground" : ""}`}
      style={sidebarOpen ? { zIndex: 500 } : {}}
    >
      <div className={`container`}>
        <div className="bars" id="navbar-bars">
          {selectedRoute?.back ? (
            <IoIosArrowBack onClick={handleGoBack} />
          ) : (
            <HiMiniBars3 onClick={openSidebar} />
          )}
        </div>

        <p className="title">{selectedRoute?.title}</p>
      </div>

      <div
        className="swipe-area"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      />

      <div
        className={`back ${sidebarOpen ? "visible" : ""}`}
        onClick={closeSidebar}
      ></div>

      <div
        className={`navigations ${sidebarOpen ? "open" : ""}`}
        style={{ transform: `translateX(${sidebarPosition}px)` }}
      >
        <div className="user-profile">
          <div
            className="image"
            onClick={() => {
              navigate(ROUTES.profile.path);
            }}
          >
            <img
              src={
                user?.image
                  ? `${IMAGE_URL}${user?.image}`
                  : "/images/profile.svg"
              }
              alt=""
              aria-label={`${user?.name}'s Profile Image`}
            ></img>
            <div
              className="user-name"
              onClick={() => {
                navigate(ROUTES.profile.path);
              }}
            >
              <p>{user?.name || "Username"}</p>
              <span>
                {organization?.subscription?.plan?.product?.name
                  ? organization?.subscription?.plan?.product?.name
                  : "Free"}{" "}
                Plan
              </span>
            </div>
          </div>
          <div
            className="subs"
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (organization?.subscription?.plan?.product?.name !== "Ultra") {
                navigate(ROUTES.upgrade.path);
              }
            }}
          >
            {organization?.subscription?.plan?.product?.name === "Ultra" ? (
              <p>You did it - Ultra unlocked 🎉</p>
            ) : (
              <p>
                Upgrade to{" "}
                <span>
                  {organization?.subscription?.plan?.product?.name
                    ? organization?.subscription?.plan?.product?.name === "Free"
                      ? "Pro"
                      : organization?.subscription?.plan?.product?.name ===
                        "Pro"
                      ? "Plus"
                      : "Ultra"
                    : " "}
                </span>
              </p>
            )}
          </div>

          <div
            className="organization-options"
            onClick={() => {
              setBranchDropDown(true);
            }}
          >
            <div className="image">
              <img
                src={
                  organization?.image
                    ? `${IMAGE_URL}${organization?.image}`
                    : "/images/noImage.svg"
                }
                className={organization?.image ? "" : "empty"}
                alt=""
                aria-label={`${organization?.name || "Organization"}'s Image`}
              />
            </div>
            <div className="right">
              <p>
                <span className="title">
                  {organization?.name || "Organization"}
                </span>
                <span>
                  <IoLocation /> {selectedBranch}
                </span>
              </p>
              <FaChevronRight />
            </div>
          </div>
        </div>

        <div className="route-list" id="navbar-bars-desktop">
          <h1 className="route-title">System</h1>

          <div className="wrapper">
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.home.path}
              className={`list ${
                selectedRoute?.rootPath === ROUTES.home.path ||
                selectedRoute?.backPath === ROUTES.home.path ||
                selectedRoute?.path === ROUTES.home.path
                  ? "active"
                  : ""
              }`}
            >
              <HiOutlineHome /> <span>Home</span>
            </Link>
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.checkout.path}
              className={`list ${
                selectedRoute?.rootPath === ROUTES.checkout.path ||
                selectedRoute?.backPath === ROUTES.checkout.path ||
                selectedRoute?.path === ROUTES.checkout.path
                  ? "active"
                  : ""
              }`}
              id="navbar-checkout"
            >
              <MdShoppingCart /> <span>Checkout</span>
            </Link>
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.sales.path}
              className={`list ${
                location.pathname === ROUTES.sales.path ? "active" : ""
              }`}
              id="navbar-sales"
            >
              <AiOutlineDollarCircle /> <span>Sales</span>
            </Link>
            <Link
              onClick={() => {
                if (!orgIsAllowedToTakeOrders.exists) {
                  dispatch(updateOpenSubscriptionAd({ openAd: true }));
                }
                setSidebarOpen(false);
              }}
              to={orgIsAllowedToTakeOrders.exists ? ROUTES.orders.path : "#"}
              className={`list ${
                location.pathname === ROUTES.orders.path ? "active" : ""
              }`}
            >
              <CiViewList /> <span>Orders</span>
            </Link>
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.manageProduct.path}
              className={`list ${
                location.pathname === ROUTES.manageProduct.path ? "active" : ""
              }`}
              id="navbar-product"
            >
              <BsBoxSeam /> <span>Products</span>
            </Link>
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.categories.path}
              className={`list ${
                location.pathname === ROUTES.categories.path ? "active" : ""
              }`}
            >
              <RiShapesFill /> <span>Categories</span>
            </Link>
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.customers.path}
              className={`list ${
                location.pathname === ROUTES.customers.path ? "active" : ""
              }`}
            >
              <IoPeople /> <span>Customers</span>
            </Link>
            {user?.is_admin || userIsAllowedToViewAnalytics ? (
              <>
                <Link
                  onClick={() => {
                    setSidebarOpen(false);
                  }}
                  to={ROUTES.analytics.path}
                  className={`list ${
                    location.pathname === ROUTES.analytics.path ? "active" : ""
                  }`}
                >
                  <SlGraph /> <span>Analytics</span>
                </Link>

                <Link
                  onClick={() => {
                    setSidebarOpen(false);
                  }}
                  to={ROUTES.aiChat.path}
                  className={`list ${
                    location.pathname === ROUTES.aiChat.path ? "active" : ""
                  }`}
                  id="navbar-sales"
                >
                  <RiRobot2Line className="icon" /> <span>AI Assistant</span>
                </Link>
              </>
            ) : (
              <></>
            )}
            {userIsAllowedToViewOrganization && (
              <Link
                onClick={() => {
                  setSidebarOpen(false);
                }}
                to={ROUTES.myOrganization.path}
                className={`list ${
                  location.pathname === ROUTES.myOrganization.path
                    ? "active"
                    : ""
                }`}
                id="navbar-organization"
              >
                <GoOrganization /> <span>My Organization</span>
              </Link>
            )}
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.manageUser.path}
              className={`list ${
                location.pathname === ROUTES.manageUser.path ? "active" : ""
              }`}
            >
              <IoPeople /> <span>Users</span>
            </Link>
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.settings.path}
              className={`list ${
                location.pathname === ROUTES.settings.path ? "active" : ""
              }`}
            >
              <IoMdSettings /> <span>Settings</span>
            </Link>
            <Link
              onClick={() => {
                setSidebarOpen(false);
              }}
              to={ROUTES.help.path}
              className={`list ${
                location.pathname === ROUTES.help.path ? "active" : ""
              }`}
            >
              <BsQuestionCircleFill /> <span>Help</span>
            </Link>
            <Link
              onClick={() => {
                setSidebarOpen(false);
                handleLogOut();
              }}
              to={ROUTES.login.path}
              className={`list logout`}
            >
              <MdLogout /> <span>Log Out</span>
            </Link>
          </div>
        </div>
      </div>

      <BranchOptions
        open={branchDropDown}
        setOpen={setBranchDropDown}
        branches={branches}
        handleBranchChange={handleBranchChange}
        selectedBranch={branch_id}
        closeNavbar={closeSidebar}
        organization={organization}
      />

      {branchDropDown ? (
        <div
          className="navbar-blur-back"
          onClick={() => {
            setBranchDropDown(false);
          }}
        ></div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Navbar;

const BranchOptions = ({
  open,
  setOpen,
  branches,
  handleBranchChange,
  selectedBranch,
  closeNavbar,
  organization,
}) => {
  const navigate = useNavigate();
  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`navbar-branch-options ${isVisible ? "active" : ""}`}>
      <p className="title">
        <IoLocation /> Select your branch
      </p>

      <div className="branch-list">
        {branches?.map((el, i) => {
          return (
            <div
              className="item"
              key={i}
              onClick={() => {
                handleBranchChange(el?.id);
                setOpen(false);
              }}
            >
              <div className="image">
                <img
                  src={
                    organization?.image
                      ? `${IMAGE_URL}${organization?.image}`
                      : "/images/noImage.svg"
                  }
                  alt=""
                  aria-label={`${el?.name || "Branch"}'s Image`}
                />
              </div>
              <p>{el?.name}</p>

              {selectedBranch === el?.id ? <MdCheckCircle /> : <></>}
            </div>
          );
        })}
      </div>

      <CustomButton
        name={"Add Branch"}
        color={"primary"}
        type={"button"}
        handleSubmit={() => {
          setOpen(false);
          closeNavbar();
          navigate(ROUTES.myOrganization.path);
        }}
        disabled={false}
        bigButton={true}
      />
    </div>
  );
};
